import React from 'react';
import { useReactToPrint } from 'react-to-print';
import Pdf from '../../../../../../../../assets/icons/pdf.svg';
import Table from '../../../../../../../../shared/components/Wrapper/Table';
import UnifiedReportPdf from './components/UnifiedReportPdf';
import { IExportPdf } from './interface';

function ExportPdf(props: IExportPdf) {
  const { data } = props;
  const componentRef: any = React.useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <>
      <div style={{ display: 'none' }}>
        <UnifiedReportPdf data={data} ref={componentRef} />
      </div>
      <Table.Button onClick={handlePrint}>
        <img src={Pdf} alt="Download em PDF" /> Download em PDF
      </Table.Button>
    </>
  );
}

export default ExportPdf;
